import { Typography } from '@material-ui/core';
import React from 'react';
import styled from '../../styled';
import { COLORS } from '../../themes/color';
import { DemoButton } from '../DemoButton';
import { Headline } from '../Headline';
import { GradientBackground } from '../HeroSection/GradientBackground';
import { SignupButton } from '../SignupButton';

const SectionArea = styled('div')`
  text-align: center;
  max-width: 750px;
  margin: 69px auto 0;
  color: ${COLORS.TEXT};
  z-index: 1;

  h2 {
    font-size: 48px;
    margin-bottom: 48px;
  }

  p {
    color: ${COLORS.TEXT};
  }
`;

const Container = styled('div')`
  background-color: ${COLORS.PAPER_DARK};
  position: relative;
  display: grid;
  align-items: center;
  overflow: hidden;
  padding: ${(p) => p.theme.spacing(2)}px;
  min-height: 500px;
`;

const DoubleSection = styled('div')`
  z-index: 1;
  display: grid;
  max-width: 1000px;
  margin: 0 auto;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: ${(p) => p.theme.spacing(4)}px;
  grid-row-gap: ${(p) => p.theme.spacing(2)}px;
  align-items: center;
  margin-bottom: 48px;

  @media (max-width: 700px) {
    margin: ${(p) => p.theme.spacing(2)}px;
    grid-template-columns: 1fr;
  }
`;

const Section = styled('div')`
  background-color: #fff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  padding: ${(p) => p.theme.spacing(4)}px;
`;

export const InfoMessage = styled('div')`
  border-radius: 8px;
  background-color: #bae7ff;
  color: #096dd9;
  font-size: 1rem;
  padding: 12px 24px;

  a {
    border-bottom: 1px solid #096dd9;
  }
`;

export const WebinarForm = () => {
  return (
    <Container>
      <GradientBackground />
      <SectionArea>
        <Headline
          component="h2"
          variant="h4"
          gutterBottom
          style={{ fontWeight: 900 }}
        >
          Scale your revenue with product intelligence and campaign automation
        </Headline>
      </SectionArea>
      <DoubleSection>
        <Section>
          <Headline component="h3" variant="h5" paragraph>
            <strong>Publishers, Brands, and Agencies</strong>
          </Headline>
          <Typography
            variant="body2"
            component="p"
            color="textSecondary"
            paragraph
          >
            Achieve the next level of revenue growth through commerce. Talk to
            us today about our publisher and brand solutions.
          </Typography>
          <DemoButton text="Book a demo" variant="contained" />
        </Section>
        <Section>
          <Headline component="h3" variant="h5" paragraph>
            <strong>Professional Creators</strong>
          </Headline>
          <Typography
            variant="body2"
            component="p"
            color="textSecondary"
            paragraph
          >
            Simplify your workflow with the insights and tools every
            professional creator needs to unlock fast and systematic affiliate
            growth.
          </Typography>
          <SignupButton text="Request early access" size="small" />
        </Section>
      </DoubleSection>
    </Container>
  );
};
